import { CellContext, createColumnHelper } from "@tanstack/react-table";
import React, { useState } from "react";
import { Col, Offcanvas } from "react-bootstrap";
import IConfirmacionMantenedor from "../../../../entities/helper/IConfirmacionMantenedor";
import { IEstadoInspeccion } from "../../../../entities/IEstadoInspeccion";
import IGerencia from "../../../../entities/IGerencia";
import IInspeccionObservacion from "../../../../entities/IInspeccionObservacion";
import ILogMantenedor from "../../../../entities/ILogMantenedor";
import ISubContratista from "../../../../entities/ISubContratista";
import IUnidad from "../../../../entities/IUnidad";
import IVicePresidencia from "../../../../entities/IVicePresidencia";
import { shortDate } from "../../../../helpers/dateHelper";
import { ITipo_Campo } from "../../../../helpers/IFormHelper";
import { getAPI, postAPI } from "../../../../helpers/httpHelper";
import { usePromiseEffect } from "../../../../helpers/promiseEffect";
import { cognitoUserInfo, cognitoUserToken } from "../../../../helpers/userHelper";
import {
  API_ADMIN_ESTADO_INSPECCION,
  API_ADMIN_FAENA,
  API_ADMIN_GERENCIA,
  API_ADMIN_MANTENEDOR_IO,
  API_ADMIN_UNIDAD,
  ROW_COUNT,
  URL_SUPPORT,
} from "../../../../helpers/variableHelper";
import AdminLista from "../../AdminLista";
import RenderForm from "../../RenderForm";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ICurrentUser from "../../../../entities/helper/ICurrentUser";
import moment from "moment";
import Select from "react-select";
import { IComboboxOption } from "../../../../entities/helper/IComboboxOption";
import LIOService from "../../../../services/LIOService";
import VppService from "../../../../services/VppService";
import CscService from "../../../../services/CscService";
import CustomToast from "../../../../cross/CustomToast";
import { cParamsActiveOrderTitle } from "../../../../helpers/paramsHelper";
import { updateFilter, updateSelectedField } from "../UtilsMantenedor";
import { downloadFile } from "../../../../helpers/fileHelper";
import ITipoFaena from "../../../../entities/ITipoFaena";
import RenderTitle from "../../../../controls/RenderTitle";
import RenderValue from "../../../../controls/RenderValue";
import RenderLink from "../../../../controls/RenderLink";

const MySwal = withReactContent(Swal);
interface IMantenedorIOProps {
  items?: Array<IInspeccionObservacion>;
  cbVicepresidencia?: Array<IVicePresidencia>;
  cbGerenciSubgerencia?: Array<IGerencia>;
  cbUnidadProyecto?: Array<IUnidad>;
  cbContratistaSubcontratista?: Array<ISubContratista>;
  cbEstadoInspeccion?: Array<IEstadoInspeccion>;
  itemsArrCambios?: Array<IConfirmacionMantenedor>;
  openPopUptest?: boolean;
}

interface IPropsColumn {
  info: CellContext<IInspeccionObservacion, number>;
  token: string;
}

const ButtonDesactivar = (info: any, token: string, preconfirm: any) => {
  return (
    <button
      className="btnIcono"
      data-testid={`btntest${info.row.original.ID}`}
      title={info.row.original.ACTIVO ? "Desactivar" : "Activar"}
      onClick={() => {
        MySwal.fire({
          html: (
            <div>
              <h3>
                ¿Desea {info.row.original.ACTIVO ? "desactivar" : "activar"} el registro {info.row.original.CORRELATIVO}?
              </h3>
            </div>
          ),
          text: "",
          icon: "question",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          showCloseButton: true,
          showCancelButton: true,
        }).then(async (result) => {
          if (result.isConfirmed) {
            if (result.isConfirmed) {
              MySwal.fire({
                html: (
                  <div>
                    <h4>Ingrese un Motivo:</h4>
                  </div>
                ),
                input: "textarea",
                inputAttributes: {
                  autocapitalize: "off",
                },
                showCancelButton: true,
                confirmButtonText: `<i class="bi bi-eye"></i>${info.row.original.ACTIVO ? "Desactivar" : "Activar"}`,
                cancelButtonText: "Cancelar",
                showLoaderOnConfirm: true,
                preConfirm: async (txtMotivo) => {
                  preconfirm(txtMotivo, info.row.original.ID, info.row.original.ACTIVO, info.row.original.CORRELATIVO);
                },
                allowOutsideClick: () => !Swal.isLoading(),
              }).then((result) => {
                if (result.isConfirmed) {
                  console.log("");
                }
              });
            }
          }
        });
      }}>
      <i className={info.row.original.ACTIVO ? "fs-5 bi bi-eye-slash btnIconoActive" : "fs-5 bi bi-eye btnIconoInactive"} />
    </button>
  );
};

const RenderValorNuevo = (info: any, comboTFMIO: any) => {
  if (info.getValue()?.TIPO === ITipo_Campo.user || info.getValue()?.TIPO === ITipo_Campo.multiuser) {
    return <i>{info.getValue()[`${info.getValue().ID}_DISPLAY`]}</i>;
  } else if (info.getValue()?.TIPO === ITipo_Campo.date) {
    return <i>{shortDate(info.getValue())}</i>;
  } else if (!isNaN(info.getValue())) {
    return <i>{comboTFMIO.filter((p: any) => p.ID === info.getValue())[0]?.TITULO}</i>;
  } else {
    return <i>{info.getValue()}</i>;
  }
};

export default function MantenedorIO({
  items,
  cbVicepresidencia,
  cbGerenciSubgerencia,
  cbUnidadProyecto,
  cbContratistaSubcontratista,
  cbEstadoInspeccion,
  itemsArrCambios,
  openPopUptest,
}: IMantenedorIOProps) {
  let paramsActive = cParamsActiveOrderTitle;
  const userInfo = cognitoUserToken();

  const [token, setToken] = useState("");
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [comboVccMIO, setComboVccMIO] = useState<Array<IVicePresidencia>>(cbVicepresidencia || []);
  const [comboUPMIO, setComboUPMIO] = useState<Array<IUnidad>>(cbUnidadProyecto || []);
  const [comboGSGMIO, setComboGSGMIO] = useState<Array<IGerencia>>(cbGerenciSubgerencia || []);
  const [comboCSCMIO, setComboCSCMIO] = useState<Array<ISubContratista>>(cbContratistaSubcontratista || []);
  const [comboEIMIO, setComboEIMIO] = useState<Array<IEstadoInspeccion>>(cbEstadoInspeccion || []);
  const [comboTFMIO, setComboTFMIO] = useState<Array<ITipoFaena>>([]);

  const [isEditColumMIO, setIsEditColumMIO] = useState<boolean>(false);
  const [editColumnInfoMIO, setEditColumnInfoMIO] = useState<any>();
  const [listItemsMIO, setListItemsMIO] = useState<Array<IInspeccionObservacion>>(items || []);
  const [isLoadingMIO, setIsLoadingMIO] = useState(false);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [showToast, setShowToastMIO] = useState(false);
  const [hideTable, setHideTableMIO] = useState(true);
  const [arrCambiosForm, setArrCambiosFormMIO] = useState<Array<IConfirmacionMantenedor>>(itemsArrCambios || []);
  const [isOpenPopUpGuardarCambios, setIsOpenPopUpGuardarCambios] = useState<boolean>(openPopUptest || false);

  const refTxtCorr = React.createRef<HTMLInputElement>();
  const [refComboVccMIO, setValComboVccMIO] = useState<IComboboxOption | null>(null);
  const [refComboUPMIO, setValComboUPMIO] = useState<IComboboxOption | null>(null);
  const [refComboGSGMIO, setValComboGSGMIO] = useState<IComboboxOption | null>(null);
  const [refComboCSCMIO, setValComboCSCMIO] = useState<IComboboxOption | null>(null);
  const [refComboEIMIO, setValComboEIMIO] = useState<IComboboxOption | null>(null);
  const [selectedFieldMIO, setSelectedFieldMIO] = useState({} as any);
  const refTxtMotivoMIO = React.createRef<HTMLTextAreaElement>();
  const refTxtFechaDesdeMIO = React.createRef<HTMLInputElement>();
  const refTxtFechaHastaMIO = React.createRef<HTMLInputElement>();

  const [pageSize, setPageSize] = useState(ROW_COUNT);
  const [isSendingData, setIsSendingData] = useState(false);
  const columnHelperMantIO = createColumnHelper<IInspeccionObservacion>();
  const columnHelperConfirmacionCambios = createColumnHelper<IConfirmacionMantenedor>();

  const preconfirm = async (txtMotivo: string, id_registro: number, activo: boolean, correlativo: string) => {
    if (!txtMotivo) {
      Swal.showValidationMessage(`Debe ingresar un motivo`);
    } else {
      await LIOService.desactivarRegistroLIO(token, {
        ID_REGISTRO: id_registro,
        AUTOR: currentUser?.email as string,
        AUTOR_DISPLAY: currentUser?.fullname as string,
        CAMPO: "N/A",
        EDITOR: currentUser?.email as string,
        EDITOR_DISPLAY: currentUser?.fullname as string,
        MODULO: "LIOS",
        TABLA: "LIO_INSPECCION_OBSERVACION",
        MOTIVO: txtMotivo,
        VALOR_INICIAL: "N/A",
        DESACTIVAR: activo,
        FECHA_CREACION: new Date(),
        FECHA_MODIFICACION: new Date(),
        VALOR_FINAL: "N/A",
        ACCION: activo ? "DESACTIVAR" : "ACTIVAR",
        CORRELATIVO: correlativo,
      });
      await handleBuscarMIO();
    }
  };

  const changeField = (id: string, valor: any, tipo: ITipo_Campo) => {
    let sf: any = updateSelectedField(id, !isNaN(valor) ? comboTFMIO.filter((p) => p.ID == valor)[0]?.TITULO : valor);
    setSelectedFieldMIO(sf);
  };
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const componentLink = (value: any) => {
    return <RenderLink value={value} />;
  };

  let columnsDef = [
    columnHelperMantIO.accessor((row) => row.CORRELATIVO, {
      id: "CORRELATIVO_COLUMNA",
      cell: (info: CellContext<IInspeccionObservacion, string>) => componentValue(info.getValue()),
      header: () => component("Correlativo"),
      hide: false,
      title: "Correlativo",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `LIO."CORRELATIVO"`,
    } as any),
    columnHelperMantIO.accessor((row) => row.ID, {
      id: "DESACTIVAR",
      cell: (info: CellContext<IInspeccionObservacion, number>) =>
        ButtonDesactivar(info, token, (txtMotivo: any, id: any, activo: any, corr: any) => {
          preconfirm(txtMotivo, id, activo, corr);
        }),
      header: () => component("Activar / Desactivar"),
      tipo: ITipo_Campo.text,
      className: "ps-3",
      disableSorting: true,
    } as any),
    columnHelperMantIO.accessor((row) => row.ACTIVO, {
      id: "ACTIVO",
      cell: (info: CellContext<IInspeccionObservacion, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
      header: () => <span>Activo</span>,
      tipo: ITipo_Campo.check,
      title: "Activo",
    } as any),
    columnHelperMantIO.accessor((row) => row.ESTADO_INSPECCION_OBSERVACION, {
      id: "ESTADO_COLUMNA",
      cell: (info: CellContext<IInspeccionObservacion, string>) => componentValue(info.getValue()),
      header: () => component("Estado"),
      hide: false,
      title: "Estado",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"ESTADO_INSPECCION_OBSERVACION"`,
    } as any),
    columnHelperMantIO.accessor((row) => row.TITULO, {
      id: "TITULO",
      cell: (info: CellContext<IInspeccionObservacion, string>) => componentValue(info.getValue()),
      header: () => component("Título"),
      hide: false,
      title: "Título",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `LIO."TITULO"`,
    } as any),
    columnHelperMantIO.accessor((row) => row.VICEPRESIDENCIA, {
      id: "VICEPRESIDENCIA_COLUMNA",
      cell: (info: CellContext<IInspeccionObservacion, string>) => componentValue(info.getValue()),
      header: () => component("Vicepresidencia"),
      hide: false,
      title: "Vicepresidencia",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"VICEPRESIDENCIA"`,
    } as any),
    columnHelperMantIO.accessor((row) => row.GERENCIA_SUBGERENCIA, {
      id: "GERENCIA_SUBGERENCIA_COLUMNA",
      cell: (info: CellContext<IInspeccionObservacion, string>) => componentValue(info.getValue()),
      header: () => component("Gerencia Subgerencia"),
      hide: false,
      title: "Gerencia Subgerencia",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"GERENCIA_SUBGERENCIA"`,
    } as any),
    columnHelperMantIO.accessor((row) => row.UNIDAD_PROYECTO, {
      id: "UNIDAD_PROYECTO_COLUMNA",
      cell: (info: CellContext<IInspeccionObservacion, string>) => componentValue(info.getValue()),
      header: () => component("Unidad Proyecto"),
      hide: false,
      title: "Unidad Proyecto",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"UNIDAD_PROYECTO"`,
    } as any),
    columnHelperMantIO.accessor((row) => row.CONTRATISTA_SUBCONTRATISTA, {
      id: "CONTRATISTA_SUBCONTRATISTA_COLUMNA",
      cell: (info: CellContext<IInspeccionObservacion, string>) => componentValue(info.getValue()),
      header: () => component("Contratista SubContratista"),
      hide: false,
      title: "Contratista SubContratista",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"CONTRATISTA_SUBCONTRATISTA"`,
    } as any),
    columnHelperMantIO.accessor((row) => row.FECHA_DETECCION, {
      id: "FECHA_DETECCION",
      cell: (info: CellContext<IInspeccionObservacion, string>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Detección"),
      hide: false,
      title: "Fecha Detección",
      tipo: ITipo_Campo.date,
      className: "colorGris",
      sortId: `LIO."FECHA_DETECCION"`,
    } as any),
    columnHelperMantIO.accessor((row) => row.FECHA_CREACION, {
      id: "FECHA_CREACION",
      cell: (info: CellContext<IInspeccionObservacion, string>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Creación"),
      hide: false,
      title: "Fecha Detección",
      tipo: ITipo_Campo.date,
      className: "colorGris",
      sortId: `LIO."FECHA_CREACION"`,
    } as any),
    columnHelperMantIO.accessor((row) => row.USUARIO_ENCARGADO_ZO_DISPLAY || row.USUARIO_ENCARGADO_ZO, {
      id: "ENCARGADO_ZONAL",
      cell: (info: CellContext<IInspeccionObservacion, string>) => componentLink(info.getValue()),
      header: () => component("Encargado Zonal"),
      hide: false,
      title: "Encargado Zonal",
      tipo: ITipo_Campo.multiuser,
      onSelectColumn: (cell: any) => {
        setEditColumnInfoMIO(cell);
        setIsEditColumMIO(true);
        setIsSendingData(false);
      },
      sortId: `LIO."USUARIO_ENCARGADO_ZO_DISPLAY"`,
    } as any),
    columnHelperMantIO.accessor((row) => row.AUTOR_DISPLAY || row.AUTOR, {
      id: "AUTOR",
      cell: (info: CellContext<IInspeccionObservacion, string>) => componentLink(info.getValue()),
      header: () => component("Autor Responsable"),
      hide: false,
      title: "Autor Responsable",
      tipo: ITipo_Campo.user,
      onSelectColumn: (cell: any) => {
        setEditColumnInfoMIO(cell);
        setIsEditColumMIO(true);
        setIsSendingData(false);
      },
      sortId: `LIO."AUTOR_DISPLAY"`,
    } as any),
    columnHelperMantIO.accessor((row) => row.HORARIO, {
      id: "FAENA",
      cell: (info: CellContext<IInspeccionObservacion, string>) => componentLink(info.getValue()),
      header: () => component("Faena"),
      hide: false,
      title: "Faena",
      tipo: ITipo_Campo.combo,
      onSelectColumn: async (cell: any) => {
        const resultTF = (
          await getAPI(
            `${URL_SUPPORT}${API_ADMIN_FAENA}/getall`,
            { Authorization: `Bearer ${token}` },
            {
              ...paramsActive,
              NOMBRE_TIPO_FAENA: cell.row.original.TIPO_FAENA,
            }
          )
        ).result.data;
        setComboTFMIO(resultTF);
        setEditColumnInfoMIO(cell);
        setIsEditColumMIO(true);
        setIsSendingData(false);
      },
      sortId: `LIO."HORARIO"`,
    } as any),
  ] as any;

  usePromiseEffect(async () => {
    setIsLoadingMIO(true);
    let token = await userInfo;
    setToken(token);
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);

    const resultComboVccMIO = openPopUptest ? [] : (await VppService.getAll(token, paramsActive)).result.data;
    setComboVccMIO(resultComboVccMIO);
    const resultComboCSCMIO = openPopUptest ? [] : (await CscService.getAll(token, paramsActive)).result.data;
    setComboCSCMIO(resultComboCSCMIO);
    const resultComboEIMIO = openPopUptest
      ? []
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_ESTADO_INSPECCION}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)).result.data;
    setComboEIMIO(resultComboEIMIO);
  }, []);

  const paging = (page: any) => {
    setPage(page);
    filterMIO({ PAGINA: page }, true);
  };

  const filterMIO = (filterMIO: any, page: boolean = false, size = pageSize) => {
    filterMIO = updateFilter(filterMIO, size, page);
    setPage(filterMIO.PAGINA);

    const valCorr = refTxtCorr.current?.value;
    const valVcc = refComboVccMIO?.value;
    const valUP = refComboUPMIO?.value;
    const valGSG = refComboGSGMIO?.value;
    const valCSC = refComboCSCMIO?.value;
    const valED = refComboEIMIO?.value;
    filterMIO.UNIDAD_PROYECTO = valUP;
    filterMIO.GERENCIA_SUBGERENCIA = valGSG;
    filterMIO.VICEPRESIDENCIA = valVcc;
    filterMIO.CONTRATISTA_SUBCONTRATISTA = valCSC;
    filterMIO.ESTADO = valED;
    filterMIO.CORRELATIVO = valCorr;
    filterMIO.FECHA_DETECCION_DESDE = refTxtFechaDesdeMIO.current?.value;
    filterMIO.FECHA_DETECCION_HASTA = refTxtFechaHastaMIO.current?.value;

    getAPI(`${URL_SUPPORT}${API_ADMIN_MANTENEDOR_IO}/getall`, { Authorization: `Bearer ${token}` }, filterMIO)
      .then((result) => {
        setIsLoadingMIO(false);
        setListItemsMIO(result.result.data);
        let pages = result.result.pages;
        setPages(pages);
      })
      .catch((error) => {});
  };

  const exportFileMIO = () => {
    const valCorr = refTxtCorr.current?.value;
    const valVcc = refComboVccMIO?.value;
    const valUP = refComboUPMIO?.value;
    const valGSG = refComboGSGMIO?.value;
    const valCSC = refComboCSCMIO?.value;
    const valED = refComboEIMIO?.value;
    let params = {
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
      ORDENADOPOR: "ID",
      ORIENTACION: "DESC",
      UNIDAD_PROYECTO: valUP,
      GERENCIA_SUBGERENCIA: valGSG,
      VICEPRESIDENCIA: valVcc,
      CONTRATISTA_SUBCONTRATISTA: valCSC,
      ESTADO: valED,
      CORRELATIVO: valCorr,
    };

    getAPI(`${URL_SUPPORT}${API_ADMIN_MANTENEDOR_IO}/Export`, { Authorization: `Bearer ${token}` }, params).then((r) => {
      downloadFile(r.result);
    });
  };

  const editMIO = (value: any, filters: any) => {
    delete value.FECHA_CREACION;
    delete value.TRANSACTION_ID;
    value.AUTOR = "";
    value.AUTOR_DISPLAY = "";
    value.EDITOR = "";
    value.EDITOR_DISPLAY = "";

    if (value.ID === "") {
      delete value.ID;
    }
  };

  const searchValidationMIO = (params: any) => {
    let arrError = [];
    if (
      !params.CORRELATIVO &&
      !params?.UNIDAD_PROYECTO &&
      !params?.GERENCIA_SUBGERENCIA &&
      !params?.VICEPRESIDENCIA &&
      !params?.CONTRATISTA_SUBCONTRATISTA &&
      !params?.ESTADO &&
      !params?.FECHA_DETECCION_DESDE &&
      !params?.FECHA_DETECCION_HASTA
    ) {
      if (!params.FECHA_DETECCION_DESDE) {
        arrError.push("Fecha desde válida");
      }
      if (!params.FECHA_DETECCION_HASTA) {
        arrError.push("Fecha hasta válida");
      }
    } else {
      if (params.FECHA_DETECCION_DESDE && params.FECHA_DETECCION_HASTA) {
        if (moment(params.FECHA_DETECCION_DESDE) > moment(params.FECHA_DETECCION_HASTA)) {
          arrError.push("Fecha hasta no puede ser menor que fecha desde");
        }
      }
    }

    if (arrError.length > 0) {
      MySwal.fire({
        html: (
          <div>
            <h5>Favor seleccione lo siguiente:</h5>
            {arrError.map((e, i) => {
              return <p key={e}>{e}</p>;
            })}
          </div>
        ),
        icon: "warning",
        cancelButtonText: "Cerrar",
        showConfirmButton: false,
        showCloseButton: true,
        showCancelButton: true,
      });
    }

    return arrError.length === 0;
  };

  const handleBuscarMIO = async () => {
    setIsLoadingMIO(true);
    const valCorr = refTxtCorr.current?.value;
    const valVcc = refComboVccMIO?.value === "Seleccione" ? "" : refComboVccMIO?.value;
    const valUP = refComboUPMIO?.value === "Seleccione" ? "" : refComboUPMIO?.value;
    const valGSG = refComboGSGMIO?.value === "Seleccione" ? "" : refComboGSGMIO?.value;
    const valCSC = refComboCSCMIO?.value === "Seleccione" ? "" : refComboCSCMIO?.value;
    const valED = refComboEIMIO?.value === "Seleccione" ? "" : refComboEIMIO?.value;
    let params = {
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
      ORDENADOPOR: "ID",
      ORIENTACION: "DESC",
      UNIDAD_PROYECTO: valUP,
      GERENCIA_SUBGERENCIA: valGSG,
      VICEPRESIDENCIA: valVcc,
      CONTRATISTA_SUBCONTRATISTA: valCSC,
      ESTADO: valED,
      CORRELATIVO: valCorr,
      FECHA_DETECCION_DESDE: refTxtFechaDesdeMIO.current?.value,
      FECHA_DETECCION_HASTA: refTxtFechaHastaMIO.current?.value,
    };

    if (openPopUptest || searchValidationMIO(params)) {
      const result = openPopUptest
        ? { data: items, pages: 10 }
        : (await getAPI(`${URL_SUPPORT}${API_ADMIN_MANTENEDOR_IO}/getall`, { Authorization: `Bearer ${token}` }, params)).result;
      setArrCambiosFormMIO([]);
      let list = result.data;
      setListItemsMIO(list);
      let pages = result.pages;
      setPages(pages);
      setHideTableMIO(false);
      setIsLoadingMIO(false);
    }
  };

  return (
    <section>
      <button
        hidden={true}
        onClick={() => {
          preconfirm("", 1, true, "");
          preconfirm("ss", 1, true, "");
        }}
        data-testid="btntest1"></button>
      <div className="row">
        <button
          hidden={true}
          data-testid="test1"
          onClick={() => {
            editMIO({ ID: "" }, {});
            exportFileMIO();
          }}></button>
        <button
          hidden={true}
          data-testid="test3"
          onClick={() => {
            paging(1);
          }}></button>
        <div className="col-12">
          <div className="rounded bg-white p-2 shadow">
            <div className="container-fluid mb-2">
              <h1 className="titPrincipal colorTit mt-2">Mantenedor Inspecciones</h1>
              <div className="alert alert-warning p-1 mb-2" role="alert">
                <i className="text-info bi bi-info-circle-fill me-2"></i>
                <small>
                  <strong>Importante:</strong> Este módulo es de uso exclusivo de administración y su uso esta bajo su responsabilidad
                </small>
              </div>
              <div className="row mb-1 ajusteInput">
                <div className="col-6">
                  <Col>
                    <label>Búsqueda por Correlativo:</label>
                  </Col>
                  <Col>
                    <input type="text" ref={refTxtCorr} className="form-control form-control-sm" />
                  </Col>
                </div>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="6">
                  <label>Vicepresidencia:</label>
                  <Select
                    options={comboVccMIO.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO })) as any}
                    placeholder="Seleccione"
                    value={refComboVccMIO || ""}
                    isClearable={true}
                    onChange={async (e: any) => {
                      setValComboVccMIO(e);
                      let paramsActive = {
                        ...cParamsActiveOrderTitle,
                        VICEPRESIDENCIA: e?.value,
                      };
                      if (e?.value) {
                        const comboGSGMIO = (
                          await getAPI(`${URL_SUPPORT}${API_ADMIN_GERENCIA}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)
                        ).result.data;

                        setComboGSGMIO([]);
                        setComboGSGMIO(comboGSGMIO);
                        setComboUPMIO([]);
                      } else {
                        setComboGSGMIO([]);
                        setComboUPMIO([]);
                      }
                    }}
                  />
                </Col>
                <Col xs="12" md="6" lg="6">
                  <label>Gerencia/Subgerencia:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboGSGMIO || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboGSGMIO.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboGSGMIO(e);
                      let paramsActive = {
                        ...cParamsActiveOrderTitle,
                        NOMBRE_GERENCIA_SUBGERENCIA: e?.value,
                      };

                      if (e?.value) {
                        const comboUPMIO = (
                          await getAPI(`${URL_SUPPORT}${API_ADMIN_UNIDAD}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)
                        ).result.data;
                        setComboUPMIO(comboUPMIO);
                      } else {
                        setComboUPMIO([]);
                      }
                    }}
                  />
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="6">
                  <label>Unidad Proyecto:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboUPMIO || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboUPMIO.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboUPMIO(e);
                    }}
                  />
                </Col>
                <Col xs="12" md="6" lg="6"></Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="6">
                  <label>Contratista/Subcontratista:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboCSCMIO || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboCSCMIO.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboCSCMIO(e);
                    }}
                  />
                </Col>
                <Col xs="12" md="6" lg="6">
                  <label>Estado Inspección:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboEIMIO || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboEIMIO.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboEIMIO(e);
                    }}
                  />
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="3">
                  <label>
                    <span className="colorRojo">(*)</span>Fecha Desde(Detección):
                  </label>
                  <input type="date" ref={refTxtFechaDesdeMIO} className="form-control form-control-sm" />
                </Col>
                <Col xs="12" md="6" lg="3">
                  <label>
                    <span className="colorRojo">(*)</span>Fecha Hasta(Detección):
                  </label>
                  <input type="date" ref={refTxtFechaHastaMIO} className="form-control form-control-sm" />
                </Col>
                <Col xs="12" md="12" lg="6"></Col>
              </div>
              <div className="row mb-2 mt-2">
                <Col xs="12" md="12" lg="12">
                  <button
                    className="btn btn-primary btn-sm me-2"
                    onClick={async () => {
                      handleBuscarMIO();
                    }}>
                    {" "}
                    <i className="bi bi-search"></i> Buscar
                  </button>

                  <button
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => {
                      (refTxtCorr.current as HTMLInputElement).value = "";
                      setValComboVccMIO(null);
                      setValComboUPMIO(null);
                      setValComboGSGMIO(null);
                      setValComboCSCMIO(null);
                      setValComboEIMIO(null);
                      (refTxtFechaDesdeMIO.current as HTMLInputElement).value = "";
                      (refTxtFechaHastaMIO.current as HTMLInputElement).value = "";
                      setListItemsMIO([]);
                    }}>
                    {" "}
                    <i className="bi bi-stars"></i> Limpiar Campos
                  </button>

                  {arrCambiosForm.length > 0 && (
                    <button
                      className="btn btn-primary btn-sm me-2 float-end"
                      onClick={() => {
                        setIsOpenPopUpGuardarCambios(true);
                      }}>
                      {" "}
                      <i className="bi bi-check"></i> Guardar Cambios
                    </button>
                  )}
                </Col>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mb-1">
        <AdminLista
          reload={filterMIO}
          items={[]}
          callback={editMIO}
          data={listItemsMIO}
          tipo={"MantenedorDesviaciones"}
          filter={filterMIO}
          pagination={{ pages: pages, page: page, paging: paging }}
          title=""
          hideAdd={true}
          hideExport={true}
          exportar={exportFileMIO}
          columnsDef={columnsDef}
          hideTable={hideTable}
          callbackUpdatePageSize={(pageSize: number, filters: Object) => {
            setPageSize(pageSize);
            filterMIO(filters, false, pageSize);
          }}
          isLoading={isLoadingMIO}
        />
      </div>

      {editColumnInfoMIO && (
        <Offcanvas
          show={isEditColumMIO}
          onHide={() => {
            setIsEditColumMIO(false);
          }}
          placement={"end"}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Editar - {editColumnInfoMIO.column.columnDef.title}</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="row mb-2">
              <div className="ajusteInput">
                <label>Valor Original</label>
              </div>
              <div>{editColumnInfoMIO && editColumnInfoMIO?.getValue()}</div>
            </div>
            <div className="row mb-2 ajusteInput">
              <div>
                <label>Nuevo Valor</label>
                <form className="form-control-sm">
                  {
                    <RenderForm
                      items={{
                        type: "FAENA",
                        value: comboTFMIO.map((vcc) => {
                          return { text: vcc.TITULO, value: vcc.ID };
                        }),
                      }}
                      id={editColumnInfoMIO?.column?.id}
                      tipoCampo={editColumnInfoMIO?.column.columnDef.tipo}
                      valor={""}
                      texto={""}
                      callback={changeField}
                    />
                  }
                </form>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-12">
                <button
                  className="btn btn-primary btn-sm me-2"
                  onClick={() => {
                    let json = selectedFieldMIO;
                    let arr = arrCambiosForm;
                    json = {
                      ID: editColumnInfoMIO.row.original.ID,
                      CAMPO_EDITADO: editColumnInfoMIO.column.columnDef.title,
                      CAMPO_EDITADO_ID: editColumnInfoMIO.column.columnDef.id,
                      VALOR_ORIGINAL: editColumnInfoMIO?.getValue(),
                      VALOR_NUEVO:
                        editColumnInfoMIO.column.columnDef.tipo === ITipo_Campo.user ||
                        editColumnInfoMIO.column.columnDef.tipo === ITipo_Campo.multiuser
                          ? selectedFieldMIO
                          : selectedFieldMIO[editColumnInfoMIO.column.columnDef.id],
                      OBJETO_REF: editColumnInfoMIO.row.original,
                      TIPO: editColumnInfoMIO.column.columnDef.tipo,
                    };
                    if (
                      !isSendingData &&
                      json.VALOR_ORIGINAL !==
                        (editColumnInfoMIO.column.columnDef.tipo === ITipo_Campo.user ||
                        editColumnInfoMIO.column.columnDef.tipo === ITipo_Campo.multiuser
                          ? json.VALOR_NUEVO[json.VALOR_NUEVO.ID + "_DISPLAY"]
                          : json.VALOR_NUEVO)
                    ) {
                      arr.push(json);
                      setArrCambiosFormMIO(arr);
                      setIsEditColumMIO(false);
                      setIsSendingData(true);
                    }
                  }}>
                  {" "}
                  <i className="bi bi-check"></i> Aceptar
                </button>

                <button
                  className="btn btn-outline-secondary btn-sm me-2"
                  onClick={() => {
                    setIsEditColumMIO(false);
                  }}>
                  {" "}
                  <i className="bi bi-x"></i> Cancelar
                </button>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      )}
      {isOpenPopUpGuardarCambios && (
        <Offcanvas
          show={isOpenPopUpGuardarCambios}
          onHide={() => {
            setIsOpenPopUpGuardarCambios(false);
          }}
          placement={"end"}
          className={"w-50"}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Confirmar Cambios</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="row mb-2">
              <span>Se realizarán los siguientes cambios en los siguientes registros de Desviaciones:</span>
            </div>
            <div className="row mb-2">
              <AdminLista
                reload={filterMIO}
                items={[]}
                callback={editMIO}
                data={arrCambiosForm}
                tipo={"MantenedorIO"}
                filter={filterMIO}
                pagination={{ pages: pages, page: page, paging: paging }}
                title=""
                hideAdd={true}
                hideExport={true}
                hideReload={true}
                hidePagination={true}
                columnsDef={[
                  columnHelperConfirmacionCambios.accessor((row) => row.ID, {
                    id: "ID",
                    cell: (info: CellContext<IConfirmacionMantenedor, string>) => componentValue(info.getValue()),
                    header: () => component("ID Registro"),
                    tipo: ITipo_Campo.text,
                  } as any),
                  columnHelperConfirmacionCambios.accessor((row) => row.CAMPO_EDITADO, {
                    id: "CAMPO_EDITADO",
                    cell: (info: CellContext<IConfirmacionMantenedor, string>) => componentValue(info.getValue()),
                    header: () => component("Campo Editado"),
                    tipo: ITipo_Campo.text,
                  } as any),
                  columnHelperConfirmacionCambios.accessor((row) => row.VALOR_ORIGINAL, {
                    id: "VALOR_ORIGINAL",
                    cell: (info: CellContext<IConfirmacionMantenedor, string>) => componentValue(info.getValue()),
                    header: () => component("Valor Original"),
                    tipo: ITipo_Campo.text,
                  } as any),
                  columnHelperConfirmacionCambios.accessor((row) => row.VALOR_NUEVO, {
                    id: "VALOR_NUEVO",
                    cell: (info: CellContext<IConfirmacionMantenedor, any>) => RenderValorNuevo(info, comboTFMIO),
                    header: () => component("Nuevo Valor"),
                    tipo: ITipo_Campo.text,
                  } as any),
                ]}
              />
            </div>
            <div className="row mb-2">
              <div className="col-12">
                <label>Motivos Modificación</label>
              </div>
              <div className="col-12">
                <textarea ref={refTxtMotivoMIO} className="w-100"></textarea>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-12">
                <button
                  className="btn btn-primary btn-sm me-2"
                  onClick={() => {
                    // NOSONAR Dejamos justificado que necesitamos estas validaciones ya que son necesarias para validar campos obligatorios del mantenedor de inspecciones
                    if (!refTxtMotivoMIO.current?.value) {
                      refTxtMotivoMIO.current?.classList.add("error");
                      return;
                    } else {
                      refTxtMotivoMIO.current?.classList.remove("error");
                    }
                    MySwal.fire({
                      html: (
                        <div>
                          <h3>¿Desea realizar los cambios con el siguiente Motivo descrito?</h3>
                          <div>(se registraran las modificaciones a su nombre y cada una asociada al motivo entregado)</div>
                        </div>
                      ),
                      text: refTxtMotivoMIO.current?.value,
                      icon: "question",
                      confirmButtonText: "Aceptar",
                      cancelButtonText: "Cancelar",
                      showCloseButton: true,
                      showCancelButton: true,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        let arrInspObs: Array<IInspeccionObservacion> = [];
                        let arrLogs: Array<ILogMantenedor> = [];

                        arrCambiosForm.forEach((ac) => {
                          if (!arrInspObs.find((d) => d.ID == ac.ID)) {
                            arrInspObs.push(ac.OBJETO_REF);
                          }
                        });

                        arrInspObs.forEach((d: any) => {
                          arrCambiosForm
                            .filter((ac) => ac.ID === d.ID)
                            .forEach((ac) => {
                              let log: ILogMantenedor = {
                                ID: null,
                                MODULO: "LIOS",
                                TABLA: "LIO_INSPECCION_OBSERVACION",
                                ID_REGISTRO: d.ID,
                                CAMPO: ac.CAMPO_EDITADO_ID,
                                VALOR_INICIAL: ac.VALOR_ORIGINAL,
                                VALOR_FINAL: null,
                                MOTIVO: refTxtMotivoMIO.current?.value || "",
                                AUTOR: currentUser?.email || "",
                                FECHA_CREACION: new Date(),
                                EDITOR: "",
                                FECHA_MODIFICACION: new Date(),
                                AUTOR_DISPLAY: currentUser?.fullname || "",
                                EDITOR_DISPLAY: "",
                                CORRELATIVO: d.CORRELATIVO,
                              };

                              if (ac.TIPO === ITipo_Campo.user || ac.TIPO === ITipo_Campo.multiuser) {
                                d[ac.CAMPO_EDITADO_ID] = ac.VALOR_NUEVO[ac.CAMPO_EDITADO_ID];
                                d[ac.CAMPO_EDITADO_ID + "_DISPLAY"] = ac.VALOR_NUEVO[ac.CAMPO_EDITADO_ID + "_DISPLAY"];
                                log.VALOR_FINAL = ac.VALOR_NUEVO[ac.CAMPO_EDITADO_ID + "_DISPLAY"];
                              } else if (ac.TIPO === ITipo_Campo.date) {
                                d[ac.CAMPO_EDITADO_ID] = moment(moment(ac.VALOR_NUEVO).format(moment.HTML5_FMT.DATE)).toDate();
                                log.VALOR_FINAL = ac.VALOR_NUEVO;
                              } else {
                                d[ac.CAMPO_EDITADO_ID] = ac.VALOR_NUEVO;
                                log.VALOR_FINAL = ac.VALOR_NUEVO;
                              }
                              arrLogs.push(log);
                            });
                        });

                        let value = {
                          LOG_MANTENEDOR: arrLogs,
                          INSPECCIONOBSERVACION: arrInspObs,
                        };

                        postAPI(`${URL_SUPPORT}${API_ADMIN_MANTENEDOR_IO}/MantenedorIO`, value, {
                          Authorization: `Bearer ${token}`,
                        })
                          .then((result) => {
                            if (refTxtMotivoMIO.current) {
                              refTxtMotivoMIO.current.value = "";
                            }
                            setArrCambiosFormMIO([]);
                            setIsOpenPopUpGuardarCambios(false);
                            setShowToastMIO(true);
                            let data = result.result.data;
                            console.log(data);
                            let params = { PAGINA: page };
                            filterMIO(params);
                          })
                          .catch((error) => {
                            console.log(error);
                          });
                      }
                    });
                  }}>
                  {" "}
                  <i className="bi bi-check"></i> Aceptar
                </button>
                <button
                  className="btn btn-outline-secondary btn-sm me-2"
                  onClick={() => {
                    setIsOpenPopUpGuardarCambios(false);
                  }}>
                  {" "}
                  <i className="bi bi-x"></i> Cancelar
                </button>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      )}
      <div className="row">
        <div className="col-12">
          <CustomToast show={showToast} title="Administración" />
        </div>
      </div>
    </section>
  );
}
